export default function useScrollTo() {
  window.scrollTo(0, 0);
  return null;
}
